import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageShell } from './layout';
import { getMondialiSectionNavItems } from '../utils/mondialiRouting';
import styles from '../styles/Mondiali.module.css';

const MONDIALI_STADIUM_IMAGE_URL = `${process.env.PUBLIC_URL || ''}/images/mondiali_bg.jpeg`;

const MondialiSectionLayout = ({
  pageTitle,
  summaryTitle,
  summaryText,
  summaryActions = null,
  activePath,
  children,
  now = null,
  bodyClassName = '',
  stadiumImageUrl = MONDIALI_STADIUM_IMAGE_URL,
}) => {
  useEffect(() => {
    if (!pageTitle) {
      return;
    }

    document.title = pageTitle;
  }, [pageTitle]);

  useEffect(() => {
    if (!bodyClassName) {
      return undefined;
    }

    document.body.classList.add(bodyClassName);
    return () => {
      document.body.classList.remove(bodyClassName);
    };
  }, [bodyClassName]);

  const navItems = getMondialiSectionNavItems(now || new Date());

  return (
    <PageShell>
      <div
        className={`${styles.mondialiSectionPage} ${styles.mondialiFlowBackground}`}
        style={{ '--mondiali-stadium-image': `url("${stadiumImageUrl}")` }}
      >
        <div className={styles.mondialiSectionContainer}>
          <section className={styles.summaryCard}>
            <h1 className={styles.summaryTitle}>{summaryTitle}</h1>
            <div className={styles.summaryCardTopRow}>
              <div className={styles.summaryText}>{summaryText}</div>
              {summaryActions ? (
                <div className={styles.shareCta}>
                  {summaryActions}
                </div>
              ) : null}
            </div>

            <nav className={styles.mondialiSectionNav} aria-label="Navigazione Mondiali">
              {navItems.map((item) => {
                const isActive = item.path === activePath;

                if (!item.enabled) {
                  return (
                    <button
                      key={item.key}
                      type="button"
                      className={`${styles.mondialiSectionNavButton} ${styles.mondialiSectionNavButtonDisabled}`}
                      disabled
                    >
                      {item.label}
                    </button>
                  );
                }

                return (
                  <Link
                    key={item.key}
                    to={item.path}
                    className={`${styles.mondialiSectionNavButton} ${isActive ? styles.mondialiSectionNavButtonActive : ''}`}
                    aria-current={isActive ? 'page' : undefined}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </section>

          {children}
        </div>
      </div>
    </PageShell>
  );
};

export default MondialiSectionLayout;
